import { GET } from "../APiHelper/API";

// Returns the seasons/cups the app should select on load: the user's saved
// preference when it is still valid, otherwise the most recently created ones.
export const getDefaultSelections = (onSuccess, onError) => {
  GET("/api/v1/seasons_and_cups/default_selections", onSuccess, onError);
};
